import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  Card,
  Row,
  Col,
  Button,
  Table,
  Modal,
  Nav,
  Tab,
  Spinner,
} from "react-bootstrap";
import ReactGA from "react-ga";
import API, { base } from "api.js";

import "react-daypicker/lib/DayPicker.css";
import DayPicker from "react-daypicker";

import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import ArrowIcon from "../assets/images/images_new/dropdown-icon.svg";
import CalenderIcon from "../assets/images/images_new/calendar-icon.svg";
import RightArrow from "assets/images/images_new/right-arrow.svg";
import SessionTour from "components/WebsiteTour/SessionTour";
import EmptyData from "components/EmptyData/EmptyData";
import BookNowModal from "components/Dashboard/New/BookNowModal";

const Home = (props) => {
  const [state, setState] = useState({
    data: [],
    group: [],
    mock: {},
    planModal: false,
    result: false,
    remarks: [],
    activeTab: 1,
    user: false,
    f: true,
    date: new Date(),
    isDate: false,
    selectedDate: "",
    dateArr: [],
    dateSelect: "",
    isTask: true,
    rec_link: "",
    rec_pwd: "",
    timezone: "",
    isLoading: false,
    countArr: {},
    showTour: false,
    isBookOpen: false,
    sessionType: null
  });

  const updateState = (newState) => {
    setState((prevState) => ({ ...prevState, ...newState }));
  };

  const toggleBookModal = () => {
    updateState({ isBookOpen: !state.isBookOpen });
  };


  const loadData = () => {
    updateState({ isLoading: true });
    API({
      method: 'GET',
      url: 'dashboard_data'
    }).then(res => {
      updateState({ sessionType: res?.data?.user?.session_type });
      if (res?.data?.user?.session_type) {
        return API({
          method: "GET",
          url: "get/session-wl",
          headers: {
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        }).then((data) => {
          updateState({
            selectedDate: data?.data?.date,
            data: data?.data?.data || [],
            timezone: data?.data?.timezone,
            showTour: true,
            isLoading: false
          });
        });
      } else {
        updateState({ data: res?.data?.data?.classes , isLoading: false });
      }
    }).catch(err => {
      updateState({ isLoading: false });
      console.log(err);
    });
  }
  useEffect(() => {
    loadData()
  }, []);
  const closePlanModal = () => {
    updateState({ planModal: !state.planModal });
  };

  const toggle = (tab) => {
    if (state.activeTab !== tab) {
      updateState({ activeTab: tab });
    }
  };

  const getUnattempted = (arr) => {
    let c = 0;
    arr.map((v) => {
      if (v.not_attempted == 0) {
        c += 1;
      }
    });
    return c;
  };

  const changeInput = (e) => {
    let { name, value } = e.target;
    if (Number.isInteger(parseInt(value)) && parseInt(value) >= 0) {
      updateState({ countArr: { ...state.countArr, [name]: +value } });
    }
  };

  const changeInputSelect = (e) => {
    let { name, value } = e.target;
    updateState({ [name]: value });
  };


  const changeDate = (date) => {
    updateState({ date: date });
    var fullDate = new Date(date);
    var twoDigitMonth = fullDate.getMonth() + 1 + "";
    if (twoDigitMonth.length == 1) twoDigitMonth = "0" + twoDigitMonth;
    var twoDigitDate = fullDate.getDate() + "";
    if (twoDigitDate.length == 1) twoDigitDate = "0" + twoDigitDate;
    var currentDate =
      fullDate.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate;

    API({
      method: "GET",
      url: "get/session-wl?date=" + currentDate,
      headers: {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    })
      .then((data) => {
        console.log(data);
        updateState({
          selectedDate: data.data.date,
          data: data.data.data,
          isDate: false,
          timezone: data.data.timezone,
        });
      })
      .catch(() => { });
  };

  const formatAMPM = (date) => {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm.toUpperCase();
    return strTime;
  };

  const formatDateTo12 = (date) => {
    let numDate = date.getDate();
    if (numDate < 10) {
      numDate = "0" + numDate;
    }
    let month = date.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    let year = date.getFullYear();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    // let strDate = `${year}-${month}-${numDate} ${hours}:${minutes} ${ampm}`;
    // return strDate;

    return {
      hours,
      minutes,
      ampm,
    };
  };

  const sydneyTime = (time) => {
    const date_time = new Date(time.replace(/-/g, "/"));
    const sydney_time = formatAMPM(date_time);

    return sydney_time;
  };

  const localTime = (time) => {
    const local_time = new Date(time.replace(/-/g, "/"));
    const data_obj = formatDateTo12(local_time);

    const { hours, minutes, ampm } = data_obj;
    return `${hours}:${minutes} ${ampm.toUpperCase()}`;
  };

  const recordingLink = (link, password) => {
    let html = "-";
    if (link) {
      html = (
        <a
          href="javascript:void(0)"
          className="link-underline-primary"
          onClick={(e) => {
            updateState({
              planModal: true,
              rec_link: link,
              rec_pwd: password,
            });
          }}
        >
          Link
        </a>
      );
    }

    return html;
  };

  // Undefined methods in class component but used in disabled code:
  const getQuestionType = () => { };
  const calculateScore = () => { };
  const calculateRemarks = () => { };




  return (
    <React.Fragment>
      <Helmet>
        <title>Top PTE Training Institute</title>
      </Helmet>
      {state.planModal && (
        <Modal show={state.planModal} onHide={closePlanModal} id="anouncementPopup" size="lg">
          <Modal.Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Modal.Title>Recording Link</Modal.Title>
            <button
              type="button"
              className="close"
              onClick={closePlanModal}
              aria-label="Close"
              style={{
                fontSize: "1.5rem",
                border: "none",
                background: "none",
                padding: "0",
                margin: "0",
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="mobileIcon">
              <Row>
                <Col md={12}>
                  <table className="table">
                    <tr>
                      <th>Link</th>
                      <th>Password</th>
                    </tr>
                    <tr>
                      <td>
                        <a
                          target="_blank"
                          href={state.rec_link}
                          className="link-underline-primary"
                          rel="noopener noreferrer"
                        >
                          Open Link
                        </a>
                      </td>
                      <td>{state.rec_pwd}</td>
                    </tr>
                  </table>
                </Col>
              </Row>
            </div>
            <div className="contentInr"></div>
          </Modal.Body>
        </Modal>
      )}
      <div className="content p-0 w-100">
        <DashboardHeader title="Live Sessions" />
        <div className="subscription-record outer-wrapper live-session">
          {state?.sessionType ?
          <div
            className="table-heading table-filter-heading"
            id="filter-and-save"
          >
            <ul>
              <li>Selected Date</li>
              <li className="active">{state.selectedDate}</li>
            </ul>
            <button
              id="filter-date-session"
              onClick={() => {
                updateState({ isDate: !state.isDate });
              }}
              className="filter-date-btn"
            >
              <img src={CalenderIcon} alt="LA" />
              Filter Date
            </button>
            <div className="calendarOuter">
              {state.isDate && (
                <DayPicker
                  className="react-daypicker-root"
                  onDayClick={changeDate}
                  active={state.date}
                />
              )}
            </div>
          </div>: <span className="complexity-badge medium mr-3">You don't have access to live sessions</span>}
          <div className="table-wrapper" id="view-session">
            <Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Title</th>
                  <th>Description</th>
                  {state?.sessionType && <th>Date</th>}
                  <th>Sydney Time</th>
                  {state?.sessionType && <th>
                    Local Time
                    <br />
                    {state.timezone && `(${state.timezone})`}
                  </th>}
                  <th>Link</th>
                  {state?.sessionType && <th>Recording</th>}
                </tr>
              </thead>
              <tbody>
                {state.isLoading ? (
                  <tr>
                    <td colSpan="8" style={{ height: "calc(100vh - 280px)" }}>
                      <Spinner animation="border" />
                    </td>
                  </tr>
                ) : (
                  state.data.length > 0 &&
                  state.data.map((val, key) => {
                    return (
                      <tr key={key}>
                        <td>{key + 1}</td>
                        <td>{val.title}</td>
                        <td>{val.description}</td>
                        {state?.sessionType && <td>{state.selectedDate}</td>}
                        <td>{sydneyTime(val.time)}</td>
                        {state?.sessionType && <td>{localTime(val.local_time)}</td>}
                        <td>
                          {state?.sessionType ? <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={val.link}
                            className="link-underline-primary"
                          >
                            Zoom Link
                          </a> : <a
                            href="#"
                            className="right-text"
                            onClick={toggleBookModal}
                          >
                            Book Now
                          </a>}
                        </td>
                        {state?.sessionType && <td>
                          {recordingLink(
                            val.recording_link,
                            val.recording_password
                          )}
                        </td>}
                      </tr>
                    );
                  })
                )}
                {/* {state.data.length > 0 && state.data.map((val, key) => {
                    return (
                      <tr key={key}>    
                      <td>{(key + 1)}</td>
                      <td>{val.title}</td>
                      <td>{val.description}</td>
                      <td>{state.selectedDate}</td>
                      <td>{sydneyTime(val.time)}</td>
                      <td>{localTime(val.local_time)}</td>
                      <td>
                        <a target="_blank" href={val.link} className="link-underline-primary">
                          Zoom Link
                        </a>
                      </td>
                      <td>{recordingLink(val.recording_link, val.recording_password)}</td>
                    </tr>
                    )
                  })}

                  {state.data.length === 0 &&
                    <tr>
                      <td colSpan="8">
                       <EmptyData/>
                        </td>
                    </tr>
                  } */}
              </tbody>
            </Table>
            {state.showTour && <SessionTour autoStart={true} dataLoaded={state.showTour} />}
            {/*<div className="dashboard-pagination">
                <ul className="dashboard-pagination-list">
                  <li><button type="button" className="pagination-list-btn prev-arrow active"><img src={ArrowIcon} alt="Arrow" /></button></li>
                  <li><button type="button" className="pagination-list-btn active-pagination">1</button></li>
                  <li><button type="button" className="pagination-list-btn">2</button></li>
                  <li><button type="button" className="pagination-list-btn">3</button></li>
                  <li><button type="button" className="pagination-list-btn">4</button></li>
                  <li><button type="button" className="pagination-list-btn next-arrow"><img src={ArrowIcon} alt="Arrow" /></button></li>
                </ul>   
                <div className="dashboard-pagination-dropdown">
                  <select name="pagination" id="pagination" className="pagination-dropdown">
                      <option value="">01</option>
                      <option value="">02</option>
                      <option value="">03</option>
                      <option value="">04</option>
                      <option value="">05</option>
                      <option value="">06</option>
                      <option value="">07</option>
                      <option value="">08</option>
                      <option value="">09</option>
                      <option value="">10</option>
                      <option value="">11</option>
                      <option value="">11</option>
                    </select>   
                    <span>/Page</span>               
                  </div>
              </div>*/}
          </div>
        </div>
        {/*<br />
          <br />
          <br />
          <br />
           <Row>
            <Col xs={12}>
              <Card>
                <Card.Header>
                  <Card.Title as="h4">Live Session(s)</Card.Title>
                </Card.Header>
                <Card.Body>
                  <h6>
                    <b>Selected Date - {state.selectedDate}</b>
                  </h6>
                  <div className="row">
                    <div className="col-md-9">
                      <Button
                        onClick={() => {
                          updateState({ isDate: !state.isDate });
                        }}
                      >
                        Choose Date
                      </Button>
                      <div className="calendarOuter">
                        {state.isDate && (
                          <DayPicker
                            className="react-daypicker-root"
                            onDayClick={changeDate}
                            active={state.date}
                          />
                        )}
                      </div>
                    </div>

                    <div className="col-md-3"></div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-md-12 tableOuter">
                      <Table>
                        <thead className="text-primary">
                          <tr>
                            <th className="">Title</th>
                            <th className="">Description</th>
                            <th className="">Time (Sydney Time)</th>
                            <th className="">
                              Local Time ({state.timezone})
                            </th>
                            <th className="">Link</th>
                            <th className="">Recording</th>
                          </tr>
                        </thead>
                        <tbody>
                          {state.data.map((val, key) => {
                            return (
                              <tr key={key}>
                                <td>{val.title}</td>
                                <td>{val.description}</td>
                                <td>
                                  {state.selectedDate +
                                    " " +
                                    formatAMPM(
                                      new Date(val.time.replace(/-/g, "/"))
                                    )}
                                </td>
                                <td>
                                  {formatDateTo12(
                                    new Date(val.local_time.replace(/-/g, "/"))
                                  )}
                                </td>
                                <td>
                                  <a target="_blank" href={val.link}>
                                    Zoom Link
                                  </a>
                                </td>
                                <td>
                                  {val.recording_link && (
                                    <a
                                      href="javascript:void(0)"
                                      onClick={(e) => {
                                        updateState({
                                          planModal: true,
                                          rec_link: val.recording_link,
                                          rec_pwd: val.recording_password,
                                        });
                                      }}
                                    >
                                      Link
                                    </a>
                                  )}
                                  {!val.recording_link && "-"}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      <br />
                      <br />
                      <br />
                    </div>

                    {false && Object.keys(state.group).length > 0 && (
                      <h3>Feedback</h3>
                    )}
                    <div className="col-sm-12 feedbackCntnt">
                      {false &&
                        Object.keys(state.group).map((val, key) => {
                          return (
                            <div className="remarksBreakdown">
                              <h5>{getQuestionType(parseInt(val))}</h5>
                              <p>
                                <b>Question Attempted</b> -{" "}
                                {state.group[val].length}
                              </p>
                              <p>
                                <b>Score Percentage</b> -{" "}
                                {calculateScore(state.group[val])} %
                              </p>
                              <p>
                                {" "}
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: calculateRemarks(
                                      state.group[val]
                                    ),
                                  }}
                                ></p>
                              </p>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row> */}
      </div>
      <BookNowModal isOpen={state.isBookOpen} toggle={toggleBookModal} />
    </React.Fragment>
  );
};

export default Home;
